import type { InterviewNowModel } from "../../../../viewjobOneGraphModel";

import { DwellTrackedSection } from "../../../../context/DwellTrackedSection";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";
import { ApplicantInsightsWithContext } from "../../../mosaic/ApplicantInsights/ApplicantInsights";
import { ProInsightsWithContext } from "../../../mosaic/ProInsights";
import { AskCareerScoutStartersSection } from "../../AskCareerScoutStarters/AskCareerScoutStartersSection";
import {
  CAREER_SCOUT_ALWAYS_AWARE_BUCKETS,
  useCareerScoutAlwaysAwareBucket,
} from "../../AskCareerScoutStarters/proctor";
import { HiringEventsViewJobDetailsWithContext } from "../../HiringEvents/components/HiringEventsViewJobDetails";
import { HiringEventsViewJobOverviewWithContext } from "../../HiringEvents/components/HiringEventsViewJobOverview";
import { PreferencesCollectionWithContext } from "../../ProfileInsights/components/PreferencesCollection";
import { QualificationCollectionWithContext } from "../../ProfileInsights/components/QualificationCollection";
import { Benefits } from "../Benefits";
import { LazyCompanyConquestingJobCards } from "../CompanyConquesting/LazyCompanyConquestingJobCards";
import { EmployerInsightsWithContext } from "../EmployerInsights/EmployerInsights";
import { InterviewNowDetails } from "../InterviewNow/InterviewNowDetails";
import { OGWrappedJobDescription } from "../JobDescription/JobDescription";
import { JobLocationSectionOneGraphWrapper } from "../JobLocationSection/JobLocationSection";
import { StructuredJobSummary } from "../JobSummaryTest";

import React from "react";

// Job tab content component
export function JobContent({
  jobKey,
  loggedIn,
  reload,
  interviewNowModel,
  hideBenefitsSection,
  hideJobDetailsSection,
  hideJobLocationSection,
  hideCompanyConquesting,
}: {
  jobKey: string;
  loggedIn: boolean;
  reload: () => void;
  interviewNowModel?: InterviewNowModel;
  hideBenefitsSection?: boolean;
  hideJobDetailsSection?: boolean;
  hideJobLocationSection?: boolean;
  hideCompanyConquesting?: boolean;
}) {
  const viewjobOneGraphModel = useViewjobOneGraphModel();
  const showCsStartersSection =
    useCareerScoutAlwaysAwareBucket() === CAREER_SCOUT_ALWAYS_AWARE_BUCKETS.SEPARATE;

  const isProInsightsActive =
    viewjobOneGraphModel?.features?.isJsProVjProInsightsTogActive ?? false;

  return (
    <>
      <StructuredJobSummary
        structuredJobSummaryModel={viewjobOneGraphModel?.structuredDataJobSummaryModel}
        jobDuties={viewjobOneGraphModel?.jobDuties}
      />
      {isProInsightsActive ? (
        <ProInsightsWithContext reload={reload} />
      ) : (
        <ApplicantInsightsWithContext reload={reload} />
      )}
      {showCsStartersSection && <AskCareerScoutStartersSection />}
      <DwellTrackedSection section="matchOverview">
        <QualificationCollectionWithContext />
      </DwellTrackedSection>
      {!hideJobDetailsSection && <PreferencesCollectionWithContext />}
      <HiringEventsViewJobOverviewWithContext />
      {!hideJobLocationSection && <JobLocationSectionOneGraphWrapper />}
      {!hideBenefitsSection && (
        <DwellTrackedSection section="benefits">
          <Benefits />
        </DwellTrackedSection>
      )}
      {!isProInsightsActive && <EmployerInsightsWithContext />}
      <DwellTrackedSection section="fullJobDescription">
        <OGWrappedJobDescription />
      </DwellTrackedSection>
      <HiringEventsViewJobDetailsWithContext />
      {!hideCompanyConquesting && (
        <DwellTrackedSection section="otherJobRecommendations">
          <LazyCompanyConquestingJobCards jobKey={jobKey} loggedIn={loggedIn} />
        </DwellTrackedSection>
      )}
      {!!interviewNowModel && <InterviewNowDetails />}
    </>
  );
}
